import { z } from 'zod';
/** Public operational projection; never contains prompts, credentials, or raw logs. */
export const AgentWorkflowSnapshotSchema = z.object({
    contract_version: z.literal(1),
    observed_at: z.iso.datetime({ offset: true }),
    actions: z
        .array(z.object({
        action_id: z.string().min(1),
        status: z.string().min(1),
        ownership_mode: z.string().min(1),
        routine: z.string().min(1),
        work_kind: z.string().min(1),
        repository: z.string().regex(/^the-langston-co\/[a-zA-Z0-9_.-]+$/),
        pr_number: z.number().int().positive(),
        head_sha: z.string().optional().nullable(),
        next_action: z.string().max(2000).optional().nullable(),
        run_url: z.url().optional().nullable(),
    }))
        .max(100),
    pull_requests: z
        .array(z.object({
        repository: z.string().regex(/^the-langston-co\/[a-zA-Z0-9_.-]+$/),
        number: z.number().int().positive(),
        url: z.url(),
        title: z.string(),
        head_sha: z.string(),
        state: z.enum(['open', 'closed', 'merged']),
        checks: z.enum(['pending', 'passed', 'failed', 'unknown']),
        review: z.enum(['approved', 'changes_requested', 'pending', 'unknown']),
        greptile: z.enum(['ready', 'pending', 'failed', 'unknown']),
        observed_at: z.iso.datetime({ offset: true }),
        deployment: z.enum(['verified', 'pending', 'unknown']),
        blockers: z.array(z.string().max(1000)).max(50),
    }))
        .max(25),
    source_errors: z.array(z.string().max(2000)).max(100).default([]),
});
